import { Component, AfterViewInit, Input, ChangeDetectorRef, ViewChild, OnDestroy } from '@angular/core';
import { Router } from '@angular/router'; // Router import
import { HttpService } from 'src/app/http.service';
import { MessagingService } from 'src/app/messaging.service';
import { PreferenceService } from 'src/app/preference.service';
import { Subscription } from 'rxjs';

@Component({
  selector: 'app-sidebar',
  templateUrl: './sidebar.component.html',
  styleUrls: ['./sidebar.component.scss']
})
export class SidebarComponent implements AfterViewInit, OnDestroy {

  public readonly manual_all_companies = '__manual_all_companies__';

  public selected_company: any;
  public permission: any;
  public company: any = [];
  public new_deposit_count: number = 0;
  public menus: any = [];
  public workspacePermissions: any = {};
  public activeLang = 'en';

  // ── Menu preference (favourites) ──
  // favMode  = user is currently picking which features to pin
  // showAll  = the collapsed full menu is temporarily expanded
  // favorites = ids (item.path/route) the user pinned, persisted per-user
  public favMode = false;
  public showAll = false;
  public favorites: string[] = [];
  // Cached favourites view. Rebuilt ONLY when menus/favourites change — never
  // recomputed inside change detection (a getter here recreated objects every CD
  // pass, which thrashed *ngFor + routerLinkActive into a hang).
  public favoriteMenus: any[] = [];

  // ── Collapsible groups ──
  // expandedGroups = raw (untranslated) group titles currently open. Default is
  // "Operation" only; the rest start collapsed. Persisted per-user.
  public expandedGroups: string[] = [];
  private static readonly DEFAULT_EXPANDED = ['Operation'];
  private notificationTokenSubscription: Subscription;

  private i18n: { [lang: string]: { [key: string]: string } } = {
    ms: {
      // UI
      'Company': 'Syarikat',
      'Password': 'Kata Laluan',
      'Exit': 'Keluar',
      // Favourites UI
      'Favorites': 'Kegemaran',
      'More': 'Lagi',
      'Less': 'Kurang',
      'Customize': 'Sesuaikan',
      'Done': 'Selesai',
      'Pick the features you use most': 'Pilih ciri yang anda kerap guna',
      // Groups
      'General': 'Umum',
      'Operation': 'Operasi',
      'Voucher (V1 Frontend)': 'Baucar (V1 Muka Depan)',
      'Winlose Report': 'Laporan Menang/Kalah',
      'Admin Report': 'Laporan Pentadbir',
      'Accounting': 'Perakaunan',
      'Export': 'Eksport',
      'General Setting': 'Tetapan Umum',
      'Game Setting': 'Tetapan Permainan',
      'Promotion Setting': 'Tetapan Promosi',
      'Transfer Wallet Setting': 'Tetapan Dompet Pindahan',
      'Frontend Setting': 'Tetapan Muka Depan',
      'Other Setting': 'Tetapan Lain',
      'Admin': 'Pentadbir',
      // Operation items
      'Player Management v1': 'Pengurusan Pemain v1',
      'Player Management': 'Pengurusan Pemain',
      'Dashboard': 'Papan Pemuka',
      'Consolidated Dashboard': 'Papan Pemuka Gabungan',
      'Consolidated Daily Sales Report': 'Laporan Jualan Harian Gabungan',
      'Consolidated Summary Report': 'Laporan Ringkasan Gabungan',
      'Withdraw Management': 'Pengurusan Pengeluaran',
      'Deposit Management': 'Pengurusan Deposit',
      'Seemless Wallet Topup/Withdraw': 'Topup/Pengeluaran Dompet Lancar',
      'Transfer Wallet Topup/Withdraw': 'Topup/Pengeluaran Dompet Pindahan',
      'Manual Wallet Topup/Withdraw': 'Topup/Pengeluaran Dompet Manual',
      'Unknown Payment': 'Bayaran Tidak Dikenali',
      'Internal Note': 'Nota Dalaman',
      'Chat': 'Sembang',
      'Notification': 'Pemberitahuan',
      'Latest SMS TAC Log': 'Log TAC SMS Terkini',
      'Partnership': 'Perkongsian',
      // Winlose items
      'Banks Winlose': 'Menang/Kalah Bank',
      'Players Summary': 'Ringkasan Pemain',
      'Players Winlose': 'Menang/Kalah Pemain',
      'Games Winlose': 'Menang/Kalah Permainan',
      // Admin Report items
      'Agent Log': 'Log Ejen',
      'Payment Gateway Log': 'Log Gerbang Pembayaran',
      'Promotion Log': 'Log Promosi',
      'Banks Report': 'Laporan Bank',
      'Topup Point Only Log': 'Log Topup Poin Sahaja',
      'Game Log': 'Log Permainan',
      'Company Agent Report': 'Laporan Ejen Syarikat',
      'Games Report': 'Laporan Permainan',
      'Agent Line Win/Loss': 'Menang/Kalah Barisan Ejen',
      // General Setting items
      'Adjustment': 'Pelarasan',
      'Bank Management': 'Pengurusan Bank',
      'Player Level Management': 'Pengurusan Tahap Pemain',
      'Payment Method Management': 'Pengurusan Kaedah Pembayaran',
      // Game Setting items
      'Disable Game': 'Nyahaktif Permainan',
      'Game Category Management': 'Pengurusan Kategori Permainan',
      'Hot Game Management': 'Pengurusan Permainan Popular',
      'Rolling Management': 'Pengurusan Rolling',
      'Seemless Game Management': 'Pengurusan Permainan Lancar',
      'Transfer Game Management': 'Pengurusan Permainan Pindahan',
      'Manual Game Management': 'Pengurusan Permainan Manual',
      // Promotion Setting items
      'Promotion Category Management': 'Pengurusan Kategori Promosi',
      'Promotion Management': 'Pengurusan Promosi',
      // Transfer Wallet Setting items
      'Transfer Wallet Integration': 'Integrasi Dompet Pindahan',
      // Frontend Setting items
      'Lucky Draw Setting': 'Tetapan Cabutan Bertuah',
      'SEO Setting': 'Tetapan SEO',
      // Other Setting items
      'Chat Template': 'Templat Sembang',
      'Company Setting': 'Tetapan Syarikat',
      'Automated Rules': 'Peraturan Automatik',
      'Chat Channels': 'Saluran Sembang',
      'MultiChat Servers': 'Pelayan MultiChat',
      'Pairing Device List': 'Senarai Peranti Berpasangan',
      // Accounting items
      'Expenses Report': 'Laporan Perbelanjaan',
      'Daily Sales Report (Old)': 'Laporan Jualan Harian (Lama)',
      'Summary Report (Old)': 'Laporan Ringkasan (Lama)',
      'Daily Sales Report': 'Laporan Jualan Harian',
      'Summary Report': 'Laporan Ringkasan',
      // Export items
      'Export Data': 'Eksport Data',
      // Admin items
      'Banker Group Management': 'Pengurusan Kumpulan Banker',
      'Domain Management': 'Pengurusan Domain',
      'Admin User Management': 'Pengurusan Pengguna Pentadbir',
      // Voucher items
      'Voucher Usage (Random)': 'Penggunaan Baucar (Rawak)',
      'Voucher Generator': 'Penjana Baucar',
      'Voucher Code': 'Kod Baucar',
    },
    cn: {
      // UI
      'Company': '公司',
      'Password': '密码',
      'Exit': '退出',
      // Favourites UI
      'Favorites': '常用',
      'More': '更多',
      'Less': '收起',
      'Customize': '自定义',
      'Done': '完成',
      'Pick the features you use most': '选择你常用的功能',
      // Groups
      'General': '常规',
      'Operation': '运营',
      'Voucher (V1 Frontend)': '优惠券 (V1 前端)',
      'Winlose Report': '输赢报告',
      'Admin Report': '管理报告',
      'Accounting': '会计',
      'Export': '导出',
      'General Setting': '常规设置',
      'Game Setting': '游戏设置',
      'Promotion Setting': '促销设置',
      'Transfer Wallet Setting': '转账钱包设置',
      'Frontend Setting': '前端设置',
      'Other Setting': '其他设置',
      'Admin': '管理员',
      // Operation items
      'Player Management v1': '玩家管理 v1',
      'Player Management': '玩家管理',
      'Dashboard': '仪表盘',
      'Consolidated Dashboard': '综合仪表盘',
      'Consolidated Daily Sales Report': '综合每日销售报告',
      'Consolidated Summary Report': '综合汇总报告',
      'Withdraw Management': '提款管理',
      'Deposit Management': '充值管理',
      'Seemless Wallet Topup/Withdraw': '无缝钱包 充值/提款',
      'Transfer Wallet Topup/Withdraw': '转账钱包 充值/提款',
      'Manual Wallet Topup/Withdraw': '手动钱包 充值/提款',
      'Unknown Payment': '未知付款',
      'Internal Note': '内部备注',
      'Chat': '聊天',
      'Notification': '通知',
      'Latest SMS TAC Log': '最新短信验证日志',
      'Partnership': '合作伙伴',
      // Winlose items
      'Banks Winlose': '银行输赢',
      'Players Summary': '玩家汇总',
      'Players Winlose': '玩家输赢',
      'Games Winlose': '游戏输赢',
      // Admin Report items
      'Agent Log': '代理日志',
      'Payment Gateway Log': '支付网关日志',
      'Promotion Log': '促销日志',
      'Banks Report': '银行报告',
      'Topup Point Only Log': '充值积分日志',
      'Game Log': '游戏日志',
      'Company Agent Report': '公司代理报告',
      'Games Report': '游戏报告',
      'Agent Line Win/Loss': '代理线路输赢',
      // General Setting items
      'Adjustment': '调整',
      'Bank Management': '银行管理',
      'Player Level Management': '玩家等级管理',
      'Payment Method Management': '支付方式管理',
      // Game Setting items
      'Disable Game': '禁用游戏',
      'Game Category Management': '游戏分类管理',
      'Hot Game Management': '热门游戏管理',
      'Rolling Management': 'Rolling 管理',
      'Seemless Game Management': '无缝游戏管理',
      'Transfer Game Management': '转账游戏管理',
      'Manual Game Management': '手动游戏管理',
      // Promotion Setting items
      'Promotion Category Management': '促销分类管理',
      'Promotion Management': '促销管理',
      // Transfer Wallet Setting items
      'Transfer Wallet Integration': '转账钱包集成',
      // Frontend Setting items
      'Lucky Draw Setting': '抽奖设置',
      'SEO Setting': 'SEO 设置',
      // Other Setting items
      'Chat Template': '聊天模板',
      'Company Setting': '公司设置',
      'Automated Rules': '自动化规则',
      'Chat Channels': '聊天渠道',
      'MultiChat Servers': 'MultiChat 服务器',
      'Pairing Device List': '配对设备列表',
      // Accounting items
      'Expenses Report': '费用报告',
      'Daily Sales Report (Old)': '每日销售报告 (旧)',
      'Summary Report (Old)': '汇总报告 (旧)',
      'Daily Sales Report': '每日销售报告',
      'Summary Report': '汇总报告',
      // Export items
      'Export Data': '导出数据',
      // Admin items
      'Banker Group Management': 'Banker 组管理',
      'Domain Management': '域名管理',
      'Admin User Management': '管理员用户管理',
      // Voucher items
      'Voucher Usage (Random)': '优惠券使用 (随机)',
      'Voucher Generator': '优惠券生成器',
      'Voucher Code': '优惠券代码',
    },
  };

  @Input() set setCompanies(value: any) {
    if (value) {
      this.company = value;
      this.cdr.detectChanges();
    }
  }

  @Input() set setSelectedCompany(value: any) {
    if (value !== "" && value) {
      if (this.selected_company != value) {
        this.selected_company = value;
        this.resetPermission();
        this.init();
        this.http.initSocket(value);
      }

      // On direct entry the route can provide the company before Firebase has
      // returned its token. Register here as well as on token emission so a
      // single-company admin never needs to use the company switcher first.
      void this.registerNotificationToken();
    }
  }

  constructor(private http: HttpService, private cdr: ChangeDetectorRef, private messagingService: MessagingService, private pref: PreferenceService, private router: Router) {
    this.company = [];
    // Favourites are scoped per user + company (see favScope). At construction
    // time no company is selected yet, so start empty; init() reloads them for
    // the active company. This keeps a favourite pinned under company X from
    // leaking into company Y where the user may lack permission for that item.
    this.favorites = [];
    this.expandedGroups = this.pref.get<string[]>('menu_expanded_groups', [...SidebarComponent.DEFAULT_EXPANDED]);
    this.getNewDepositCount();
    const savedLang = localStorage.getItem('--panel-lang');
    if (savedLang) this.activeLang = savedLang;

    // Listen for language changes from header/login
    window.addEventListener('panel-lang-change', (e: any) => {
      this.activeLang = e.detail;
      this.cdr.detectChanges();
    });

    this.notificationTokenSubscription = this.messagingService.getTokenChanges().subscribe((token) => {
      if (token && this.selected_company) {
        void this.registerNotificationToken(token);
      }
    });
  }

  ngAfterViewInit() {
    this.http.getSelectedCompany().subscribe(async (v) => {
      if (this.selected_company != v) {
        this.selected_company = v;
        this.resetPermission();
        await this.init();
        this.http.initSocket(v);
        setTimeout(() => {
          this.http.primeAudio("notification");
        }, 1000);
      }

      // BehaviorSubject replays the current company. Do this even when the
      // @Input already assigned the same value, which is the direct-entry race.
      await this.registerNotificationToken();
    });

    this.http.getNewDeposit().subscribe(async (v) => {
      await this.getNewDepositCount();
    });
  }

  async getNewDepositCount() {
    if (this.http.isViewingUser) return;
    const res: any = await this.http.post('/admin/deposit/count');
    this.new_deposit_count = res.count;
  }

  async init() {
    this.menus = [];
    this.workspacePermissions = {};
    const [raw, grants] = await Promise.all([this.http.getPermission(), this.http.getHiddenPermission()]);
    this.workspacePermissions = grants || {};
    this.menus = this.sanitizeMenus(raw);
    this.favorites = this.pref.get<string[]>(this.favScope(), []);
    this.rebuildFavoriteMenus();

    this.cdr.detectChanges();
  }

  // Favourites are remembered per user AND per company. The PreferenceService
  // already namespaces by the logged-in admin's uuid; appending the selected
  // company uuid here gives each (user, company) pair its own pinned set, so
  // favourites never bleed across companies the user is not permissioned for.
  private favScope(): string {
    return `menu_favorites::${this.selected_company || ''}`;
  }

  // Keep only real navigation links. Permission rows with menu != 1 (e.g.
  // 'Agent wallet adjustment', 'Show Number') are access flags, not pages —
  // rendering them as <a> produces dead links. Groups left with no nav child
  // are dropped so no empty section header shows.
  private sanitizeMenus(raw: any): any[] {
    if (!Array.isArray(raw)) return [];
    return raw
      .map((g: any) => ({ ...g, children: (g.children || []).filter((c: any) => Number(c.menu) === 1) }))
      .filter((g: any) => g.children.length > 0);
  }

  // ── Favourites helpers ──
  itemId(item: any): string {
    return item ? (item.path || item.route || item.title || '') : '';
  }

  isFavorite(item: any): boolean {
    return this.favorites.includes(this.itemId(item));
  }

  toggleFavorite(item: any, ev?: Event) {
    if (ev) { ev.preventDefault(); ev.stopPropagation(); }
    const id = this.itemId(item);
    if (!id) return;
    const i = this.favorites.indexOf(id);
    if (i >= 0) {
      this.favorites.splice(i, 1);
    } else {
      this.favorites.push(id);
    }
    this.favorites = [...this.favorites];
    this.pref.set(this.favScope(), this.favorites);
    this.rebuildFavoriteMenus();
  }

  // Recompute the cached favourites view. Groups reduced to only the pinned
  // children, preserving group + sort order. Called on data/selection change,
  // NOT from the template — see favoriteMenus field comment.
  private rebuildFavoriteMenus() {
    this.favoriteMenus = (this.menus || [])
      .map((m: any) => ({ ...m, children: (m.children || []).filter((c: any) => this.isFavorite(c)) }))
      .filter((m: any) => m.children.length > 0);
  }

  toggleFavMode() {
    this.favMode = !this.favMode;
    // while picking, show the whole menu so every feature is reachable
    this.showAll = this.favMode ? true : false;
  }

  toggleShowAll() {
    this.showAll = !this.showAll;
  }

  get hasFavorites(): boolean {
    return this.favorites && this.favorites.length > 0;
  }

  // ── Collapsible group helpers ──
  isGroupCollapsed(menu: any): boolean {
    const title = menu ? menu.title : '';
    return !this.expandedGroups.includes(title);
  }

  toggleGroup(menu: any, ev?: Event) {
    if (ev) { ev.preventDefault(); ev.stopPropagation(); }
    const title = menu ? menu.title : '';
    if (!title) return;
    const i = this.expandedGroups.indexOf(title);
    if (i >= 0) {
      this.expandedGroups.splice(i, 1);
    } else {
      this.expandedGroups.push(title);
    }
    this.expandedGroups = [...this.expandedGroups];
    this.pref.set('menu_expanded_groups', this.expandedGroups);
  }

  routeReplace(path: string, route: string) {
    if (path) {
      return ['/lo', this.selected_company, ...path.split("/")]
    }
    return [route.replace("company_uuid", this.selected_company)];
  }

  get companySelection() {
    return this.canUseManualAllCompanies() && this.router.url.includes('/manual-topup-withdraw')
      ? this.manual_all_companies
      : this.selected_company;
  }

  canUseIntercompanyAdjustment() {
    return this.workspacePermissions['intercompany-adjustment'] == 1 && this.workspacePermissions['wallet-adjustment'] == 1;
  }

  canUseConsolidatedWallet() {
    if (this.workspacePermissions['consolidated-wallet-all-branches'] == 1) return true;
    return this.workspacePermissions['consolidated-wallet'] == 1 &&
      ['manual-topup-withdraw', 'auto-topup-withdraw', 'wallet-topup-withdraw'].some(key => this.workspacePermissions[key] == 1);
  }

  canUseManualAllCompanies() {
    return this.menus.some(menu => Array.isArray(menu.children)
      && menu.children.some(item => item.path === 'manual-topup-withdraw'));
  }

  async setCompany(val) {
    if (val === this.manual_all_companies) {
      this.http.navigate(['/lo', this.selected_company, 'manual-topup-withdraw']);
      return;
    }
    this.http.setSelectedCompany(val);
    await this.init();
    let path = this.menus[0]?.children[0]?.path;
    if (this.http.isViewingUser) {
      path = this.http.viewAsReportPages.find(p => this.workspacePermissions[p] == 1) || 'unauthorized';
      window.location.assign('/lo/' + val + '/' + path);
      return;
    }
    this.http.navigate(['/lo', this.selected_company, path ?? "unauthorized"]);
    this.http.initSocket(val);
    await this.registerNotificationToken();
    setTimeout(() => {
      this.http.primeAudio("notification");
    }, 1000);
  }

  public refreshingCompanies = false;
  async refreshCompanies() {
    if (this.refreshingCompanies) return;
    this.refreshingCompanies = true;
    try { this.company = await this.http.setCompany(); }
    finally { this.refreshingCompanies = false; }
  }

  ngOnDestroy() {
    this.notificationTokenSubscription?.unsubscribe();
  }

  private async registerNotificationToken(token = this.messagingService.getToken()) {
    if (!this.selected_company || !token) {
      return;
    }

    await this.http.setAdminToken(token);
  }

  private resetPermission() {
    const val = this.http.getSelecetdCompanyDetail();

    // let path = this.router.url.split("/").pop()

    // if(!val.can_view && ['weekly-account', 'summary-report'].indexOf(path) == -1) {

    //   this.http.navigate(['/lo', this.selected_company, 'weekly-account']);
    // }

    this.permission = val;
  }

  applyLang(lang: { code: string }) {
    this.activeLang = lang.code;
    localStorage.setItem('--panel-lang', lang.code);
  }

  t(key: string): string {
    if (this.activeLang === 'en' || !key) return key;
    return this.i18n[this.activeLang]?.[key] || key;
  }

  logout() {
    if (this.http.isViewingUser) return this.http.exitViewAs();
    this.http.closeAllWindow();
    this.http.clearAccess();
    this.http.navigate(['/lr'])
  }

  openWhatsapp(path) {
    this.http.openWindow(path)
  }
}
